module.exports = __webpack_public_path__ + "e450150960584e04aec641048af1c855.png";